import { Link } from "react-router-dom";
import CheckboxStandalone from "../UI/CheckboxStandalone.tsx";

export default function CGVCheckbox({ checked, onChange, remboursable }) {
  return (
    <CheckboxStandalone onChange={onChange} checked={checked}>
      J'accepte les{" "}
      <Link to={"https://www.qalimo.fr/cgv/"} target={"_blank"}>
        conditions générales de vente
      </Link>
      .{" "}
      {!remboursable && <>Utilisable sans date de validité. Non remboursable</>}
    </CheckboxStandalone>
  );
}
